import VCheckbox from './VCheckbox';

VCheckbox.install = function install(Vue) {
  Vue.component(VCheckbox.name, VCheckbox);
};

export default VCheckbox;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VCheckbox/index.js
// module id = z8aH
// module chunks = 0